import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';

import { PRODUCT_SKU_CONFIG_KEYS as DATA_KEYS } from '../../../../../stubs';

export default function createFormData(data) {
  const formData = _cloneDeep(data);

  const serviceDays = _get(formData, DATA_KEYS.SERVICE_DAYS, '');
  const productVariantIds = _get(formData, DATA_KEYS.PRODUCT_VARIANTS, []);

  formData[DATA_KEYS.PRODUCTS] = [];
  formData[DATA_KEYS.SERVICE_DAYS] = `${serviceDays}`;
  formData[DATA_KEYS.PRODUCT_VARIANTS] = [...new Set(productVariantIds)];

  return formData;
}
